'use strict'

import '../stylesheets/sharable-article.scss'

const modalHandlers = () => {
  const id = document.getElementById('article-id').value
  const url = `/api/articles/${id}/limited_article_notice.json`
  fetch(url)
    .then(response => response.json())
    .then(json => {
      const modalContents = json.html
      if (modalContents === '') { return }

      const showModalHandler = () => {
        const bodyEl = document.getElementsByTagName('body')[0]
        bodyEl.insertAdjacentHTML('afterbegin', modalContents)
      }
      showModalHandler()

      const closeBtn = document.getElementById('close-btn')
      const maskEl = document.getElementById('mask')
      const modalEl = document.getElementById('modal')
      const closeModalHandler = () => {
        maskEl.classList.add('hidden')
        modalEl.classList.add('hidden')
      }
      closeBtn.addEventListener('click', closeModalHandler)
      maskEl.addEventListener('click', closeModalHandler)
    })
}

window.addEventListener('DOMContentLoaded', modalHandlers)
